export enum MediaMinWidths {
  DESKTOP = 1281,
  TABLET = 768,
}
